import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function buildReturnPath(location) {
  if (!location) {
    return '/';
  }
  return `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
}

function RequireLoginRoute({ user, authResolved = true, children }) {
  const location = useLocation();

  if (!authResolved) {
    return <div className="auth-loading-screen" data-testid="auth-loading-screen" role="status" aria-live="polite">Chargement…</div>;
  }

  if (user?.login) {
    return children;
  }

  return <Navigate to="/login" replace state={{ from: buildReturnPath(location) }} />;
}

export default RequireLoginRoute;